module.exports = __webpack_public_path__ + "media/images/ticket-partners/kassir-c552e12e6b629fcad074c3d5ccc0cd0e.svg";